const handleCartSteps = () => {
	$('.js-trigger-cart-steps').on('click', function(event) {
		const $formCart = $('.form-cart');
		const $paymentMethod = $('.payment-method');

		$formCart.toggleClass('is-current');

		$paymentMethod.toggleClass('is-current');

		event.preventDefault();
	});
}

handleCartSteps();
